import React, { useState, useEffect } from "react";
import { getClientList } from "../../api/Client";
import { Spinner } from "react-bootstrap";
import { addborders, getborders } from "../../api/border";

function ClientList() {
  const [loading, setLoading] = useState(true);
  const [borderDatas, setBorderDatas] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [isNewBorder, setIsNewBorder] = useState(false);
  const [borderName, setBorderName] = useState("");

  function borderNameHandler(e) {
    setBorderName(e.target.value);
  }

  function submitBorder(event) {
    event.preventDefault();
    if (borderName.trim() === "") {
      return alert("Border Name is required");
    }

    const borderData = { name: borderName };

    addborders(borderData, (result) => {
      if (result.ok !== 1) {
        return console.log(result);
      }
      alert("Border added successfully");
      setIsNewBorder(false);
      setBorderName("");
      getbordersList();
    });
  }

  const handleIsNewBorderVisible = () => {
    setIsNewBorder(true);
  };

  const handleCancel = () => {
    setIsNewBorder(false);
    setBorderName("");
  };

  const handleDeleteClick = (item) => {
    if (window.confirm(`Are you sure you want to delete border "${item.name}"?`)) {
      console.log('Delete border:', item);
      // TODO: Implement delete functionality
      alert('Delete functionality will be implemented with backend integration');
    }
  };

  const getbordersList = () => {
    setLoading(true);
    getborders((result) => {
      if (result.ok === 1) {
        setBorderDatas(result.result);
      } else {
        setBorderDatas([]);
      }
      setLoading(false);
    });
  };

  useEffect(() => {
    getbordersList();
  }, []);

  const filteredData = borderDatas.filter(item => 
    item.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.assign_border?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Calculate statistics
  const totalBorders = borderDatas.length;
  const activeBorders = borderDatas.filter(item => item.assign_border && item.assign_border !== "N/A").length;
  const unassignedBorders = totalBorders - activeBorders;

  const BorderCard = ({ item, index }) => (
    <div className="card border-0 shadow-sm mb-3">
      <div className="card-body">
        <div className="d-flex justify-content-between align-items-start mb-3">
          <div className="d-flex align-items-center flex-grow-1">
            <div className="bg-warning bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center me-3 flex-shrink-0" style={{width: '40px', height: '40px'}}>
              <i className="bi bi-signpost text-warning"></i>
            </div>
            <div className="flex-grow-1 min-w-0">
              <h6 className="mb-1 fw-bold text-truncate">{item.name}</h6>
              <small className="text-muted d-block">
                <i className="bi bi-hash me-1"></i>
                Border #{index + 1}
              </small>
            </div>
          </div>
          <div className="flex-shrink-0">
            {item.assign_border && item.assign_border !== "N/A" ? (
              <span className="badge bg-success">
                <i className="bi bi-check-circle me-1"></i>
                Assigned
              </span>
            ) : (
              <span className="badge bg-secondary">
                <i className="bi bi-dash-circle me-1"></i>
                Unassigned
              </span>
            )}
          </div>
        </div>

        <div className="row g-2 mb-3">
          <div className="col-12">
            <small className="text-muted d-block">Assigned Traders</small>
            <small className="fw-medium">{item.assign_border || "No traders assigned"}</small>
          </div>
        </div>

        <div className="d-grid">
          <button
            onClick={() => handleDeleteClick(item)}
            className="btn btn-outline-danger btn-sm"
          >
            <i className="bi bi-trash me-1"></i>
            Delete Border
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <div className="container-fluid p-3 p-md-4" style={{ backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
      <div className="row">
        <div className="col-12">
          {/* Header */}
          <div className="mb-4">
            <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
              <div>
                <h2 className="mb-1 fw-bold">Border Management</h2>
                <p className="text-muted">Manage border crossing points and trader assignments</p>
              </div>
              {!isNewBorder && (
                <button 
                  onClick={handleIsNewBorderVisible}
                  className="btn btn-primary"
                >
                  <i className="bi bi-plus-circle me-2"></i>
                  Add Border
                </button>
              )}
            </div>
          </div>

          {/* Stats Cards */}
          <div className="row g-3 mb-4">
            <div className="col-12 col-sm-6 col-lg-4">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="flex-grow-1">
                      <p className="text-muted mb-1 small">Total Borders</p>
                      <h3 className="mb-0 fw-bold">{totalBorders}</h3>
                    </div>
                    <div className="bg-primary bg-opacity-10 p-3 rounded flex-shrink-0">
                      <i className="bi bi-signpost fs-4 text-primary"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-sm-6 col-lg-4">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="flex-grow-1">
                      <p className="text-muted mb-1 small">Assigned Borders</p>
                      <h3 className="mb-0 fw-bold text-success">{activeBorders}</h3>
                    </div>
                    <div className="bg-success bg-opacity-10 p-3 rounded flex-shrink-0">
                      <i className="bi bi-check-circle fs-4 text-success"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-sm-6 col-lg-4">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="flex-grow-1">
                      <p className="text-muted mb-1 small">Unassigned</p>
                      <h3 className="mb-0 fw-bold text-warning">{unassignedBorders}</h3>
                    </div>
                    <div className="bg-warning bg-opacity-10 p-3 rounded flex-shrink-0">
                      <i className="bi bi-dash-circle fs-4 text-warning"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Add Border Form */}
          {isNewBorder && (
            <div className="card border-0 shadow-sm mb-4">
              <div className="card-body">
                <h6 className="card-title mb-3">
                  <i className="bi bi-plus-circle me-2"></i>
                  Add New Border
                </h6>
                <form onSubmit={submitBorder}>
                  <div className="row g-3">
                    <div className="col-12 col-md-8">
                      <label htmlFor="borderName" className="form-label fw-semibold">
                        Border Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        id="borderName"
                        onChange={borderNameHandler}
                        value={borderName}
                        className="form-control"
                        placeholder="Enter border crossing point name"
                        required
                      />
                    </div>
                    <div className="col-12 col-md-4 d-flex align-items-end gap-2">
                      <button
                        type="submit"
                        className="btn btn-success flex-fill"
                      >
                        <i className="bi bi-check-circle me-1"></i>
                        Add Border
                      </button>
                      <button
                        type="button"
                        onClick={handleCancel}
                        className="btn btn-secondary flex-fill"
                      >
                        <i className="bi bi-x-circle me-1"></i>
                        Cancel
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          )}

          {/* Search */}
          <div className="card border-0 shadow-sm mb-4">
            <div className="card-body">
              <div className="row g-3">
                <div className="col-12 col-md-8">
                  <div className="input-group">
                    <span className="input-group-text bg-white border-end-0">
                      <i className="bi bi-search text-muted"></i>
                    </span>
                    <input
                      type="text"
                      className="form-control border-start-0 ps-0"
                      placeholder="Search by border name or assigned traders..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </div>
                </div>

                <div className="col-12 col-md-4">
                  <button
                    onClick={getbordersList}
                    disabled={loading}
                    className="btn btn-outline-secondary w-100"
                    title="Refresh"
                  >
                    <i className={`bi bi-arrow-clockwise ${loading ? 'spinner-border spinner-border-sm' : ''}`}></i>
                    {loading ? ' Loading...' : ' Refresh'}
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Content */}
          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : filteredData.length === 0 ? (
            <div className="text-center py-5">
              <i className="bi bi-signpost fs-1 text-muted"></i>
              <p className="text-muted mt-2">No borders found</p>
              {!isNewBorder && (
                <button 
                  onClick={handleIsNewBorderVisible}
                  className="btn btn-primary mt-2"
                >
                  <i className="bi bi-plus-circle me-2"></i>
                  Add First Border
                </button>
              )}
            </div>
          ) : (
            <>
              {/* Mobile Card View (visible on small and medium screens) */}
              <div className="d-block d-xl-none">
                {filteredData.map((item, index) => (
                  <BorderCard key={item.id || index} item={item} index={index} />
                ))}
              </div>

              {/* Desktop Table View (visible on extra large screens) */}
              <div className="card border-0 shadow-sm d-none d-xl-block">
                <div className="card-body p-0">
                  <div className="table-responsive">
                    <table className="table table-hover align-middle mb-0">
                      <thead className="table-light">
                        <tr>
                          <th className="fw-semibold text-uppercase small border-0" style={{minWidth: '60px'}}>#</th>
                          <th className="fw-semibold text-uppercase small border-0" style={{minWidth: '200px'}}>Border Name</th>
                          <th className="fw-semibold text-uppercase small border-0" style={{minWidth: '200px'}}>Assigned Traders</th>
                          <th className="fw-semibold text-uppercase small border-0" style={{minWidth: '100px'}}>Status</th>
                          <th className="fw-semibold text-uppercase small border-0" style={{minWidth: '100px'}}>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredData.map((item, index) => (
                          <tr key={item.id || index}>
                            <td>
                              <span className="fw-medium">#{index + 1}</span>
                            </td>
                            <td>
                              <div className="d-flex align-items-center">
                                <div className="bg-warning bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center me-2 flex-shrink-0" style={{width: '32px', height: '32px'}}>
                                  <i className="bi bi-signpost text-warning small"></i>
                                </div>
                                <span className="fw-medium text-truncate" style={{maxWidth: '150px'}} title={item.name}>
                                  {item.name}
                                </span>
                              </div>
                            </td>
                            <td>
                              <span className="text-truncate d-block" style={{maxWidth: '180px'}} title={item.assign_border || "No traders assigned"}>
                                {item.assign_border || "No traders assigned"}
                              </span>
                            </td>
                            <td>
                              {item.assign_border && item.assign_border !== "N/A" ? (
                                <span className="badge bg-success">
                                  <i className="bi bi-check-circle me-1"></i>
                                  Assigned
                                </span>
                              ) : (
                                <span className="badge bg-secondary">
                                  <i className="bi bi-dash-circle me-1"></i>
                                  Unassigned
                                </span>
                              )}
                            </td>
                            <td>
                              <button 
                                onClick={() => handleDeleteClick(item)}
                                className="btn btn-sm btn-outline-danger" 
                                title="Delete"
                              >
                                <i className="bi bi-trash"></i>
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </>
          )}

          {/* Footer */}
          <div className="mt-3 text-center text-muted small">
            Showing {filteredData.length} of {borderDatas.length} borders
          </div>
        </div>
      </div>
    </div>
  );
}

export default ClientList;